import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { getWindowOrigin } from "@helper/utils";

export const DEFAULT_OG_IMAGE_WIDTH = 1200;
export const DEFAULT_OG_IMAGE_HEIGHT = 630;

const windowOrigin = removeTrailingSlash(getWindowOrigin());
const ogImage = (fileName: string) =>
  `${windowOrigin}/assets/ogImages/${fileName}.png`;

export const sectionOgImageUrl = {
  "akses-percuma": ogImage("akses-percuma"),
  "bahasa-budaya": ogImage("bahasa-budaya"),
  "bh-services": ogImage("bh-services"),
  default: ogImage("default"),
  dunia: ogImage("dunia"),
  "ekonomi-kerja": ogImage("ekonomi"),
  "gaya-hidup": ogImage("gaya-hidup"),
  "gen-g": ogImage("geng"),
  "kaki-makan": ogImage("kaki-makan"),
  "kuiz-bh": ogImage("kuiz-bh"),
  malaysia: ogImage("malaysia"),
  "mata-mata": ogImage("mata-mata"),
  multimedia: ogImage("multimedia"),
  "pengguna-berdaftar": ogImage("pengguna-berdaftar"),
  "premium-articles": ogImage("premium"),
  registered: ogImage("pengguna-berdaftar"),
  singapura: ogImage("singapura"),
  sukan: ogImage("sukan"),
  terkini: ogImage("terkini"),
  wacana: ogImage("wacana"),
  webinar: ogImage("webinar"),
};

export type SectionOgImageKey = keyof typeof sectionOgImageUrl;

const toOgImageKey = (name?: string | null) =>
  name?.trim().toLowerCase().replace(/\s+/g, "-");

/**
 * Resolves the section OG image, trying each name in order (e.g. section name
 * first, then its parent section) and falling back to the default image.
 */
export const getSectionOgImageUrl = (
  ...sectionNames: (string | null | undefined)[]
) => {
  for (const sectionName of sectionNames) {
    const key = toOgImageKey(sectionName);
    if (key && Object.hasOwn(sectionOgImageUrl, key)) {
      return sectionOgImageUrl[key as SectionOgImageKey];
    }
  }

  return sectionOgImageUrl.default;
};
